import { authUrl, baseUrl } from '@/api/types';

export function userInfoUrl() {
  return `${authUrl}/user-info`;
}

export function userPulseUrl() {
  return `${authUrl}/user-pulse`;
}

export function linkGoogleUrl() {
  return `${authUrl}/link-google`;
}

export function linkGoogleDestroyUrl() {
  return `${authUrl}/link-google`;
}

export function userEditUrl() {
  return `${baseUrl}/profile`;
}

export function userUpdateUrl() {
  return `${baseUrl}/profile`;
}

export function userDeleteUrl() {
  return `${baseUrl}/profile`;
}

export function userExportUrl() {
  return `${baseUrl}/profile/export`;
}

export function userExportDownloadUrl(id) {
  return `${baseUrl}/profile/export/${id}`;
}

export function userAgreementModalUrl() {
  return `${baseUrl}/modals/user-agreement`;
}

export function externalBannerUrl() {
  return `${baseUrl}/external-banner`;
}
